module.exports = __webpack_public_path__ + "img/shouyezuoce.0821e619.jpg";